import React from 'react';
import {
  Package,
  Truck,
  CheckCircle,
  Clock,
  MapPin,
  CalendarDays
} from 'lucide-react';
import NavbarMob from '../components/NavbarMob';
import Navbar from '../components/Navbar';
import FooterMob from '../components/FooterMob';
import Footer from '../components/Footer';

const DelhiveryTrackingShimmer = ({ isMobile = false }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className='h-max'>
        {isMobile ? <NavbarMob /> : <Navbar />}
      </div>

      {/* Main Content Shimmer */}
      <div className="w-full h-auto flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[60px]  animate-pulse">
        <div className="w-full">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">


            {/* Tracking Card Shimmer */}
            <div className="p-6 md:p-8 space-y-8">

              {/* Order Header Shimmer */}
              <div className="w-full flex flex-col gap-4">
                <div className="relative bg-gray-100 rounded-xl p-6">
                  <div className="flex flex-col gap-3">
                    <div className="flex justify-between items-center">
                      <div className="h-6 bg-gray-300 rounded w-48"></div>
                      <div className="h-8 bg-gray-300 rounded-full w-24"></div>
                    </div>
                    <div className="h-4 bg-gray-300 rounded w-64"></div>
                  </div>
                </div>

                {/* Progress Tracker Shimmer */}
                <div className="border-2 border-gray-100 rounded-2xl p-6">
                  <div className="mb-6">
                    <div className="h-5 bg-gray-300 rounded w-32 mb-2"></div>
                    <div className="h-4 bg-gray-300 rounded w-48"></div>
                  </div>

                  {/* Progress Bar Shimmer */}
                  <div className="relative mb-10">
                    <div className="h-2 bg-gray-200 rounded-full w-full"></div>
                    <div className="h-2 bg-gray-300 rounded-full w-1/2 absolute top-0 left-0"></div>

                    {/* Progress Steps Shimmer */}
                    <div className="flex justify-between mt-6">
                      {[1, 2, 3, 4, 5].map((step) => (
                        <div key={step} className="flex flex-col items-center">
                          <div className="w-10 h-10 bg-gray-300 rounded-full mb-2"></div>
                          <div className="h-3 bg-gray-300 rounded w-20"></div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Timeline Shimmer */}
                <div className="border-2 border-gray-100 rounded-2xl">
                  <div className="p-6 border-b">
                    <div className="h-5 bg-gray-300 rounded w-36"></div>
                  </div>

                  <div className="p-6 space-y-6">
                    {[1, 2, 3].map((item) => (
                      <div key={item} className="flex items-center gap-4 pb-6 border-b">
                        <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
                        <div className="flex-1 space-y-3">
                          <div className="flex items-center gap-3">
                            <div className="h-5 bg-gray-300 rounded w-32"></div>
                          </div>
                          <div className="h-3 bg-gray-200 rounded w-48"></div>
                          <div className="h-3 bg-gray-200 rounded w-56"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Shipment Details Shimmer */}
                <div className="border-2 border-gray-100 rounded-2xl">
                  <div className="p-6 border-b">
                    <div className="h-5 bg-gray-300 rounded w-40"></div>
                  </div>
                  <div className="p-6 space-y-4">
                    {[1, 2].map((item) => (
                      <div key={item} className="h-4 bg-gray-200 rounded w-full"></div>
                    ))}
                  </div>
                </div>

                {/* Order Information Shimmer */}
                <div className="border-2 border-gray-100 rounded-2xl">
                  <div className="p-6 border-b">
                    <div className="h-5 bg-gray-300 rounded w-40"></div>
                  </div>
                  <div className="p-6 space-y-4">
                    {[1, 2, 3].map((item) => (
                      <div key={item} className="flex justify-between">
                        <div className="h-4 bg-gray-200 rounded w-32"></div>
                        <div className="h-4 bg-gray-200 rounded w-48"></div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Shimmer */}
      <div className='h-max'>
        {isMobile ? <FooterMob /> : <Footer />}

      </div>
    </div>
  );
};

export default DelhiveryTrackingShimmer;